import React from 'react';

export default function Input({ label, error, hint, required, style = {}, ...props }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem', ...style }}>
      {label && (
        <label style={{ fontSize: '0.9375rem', fontWeight: 600, color: error ? 'var(--color-danger)' : 'var(--color-text)', lineHeight: 1.4 }}>
          {label}{required && <span style={{ color: 'var(--color-danger)', marginLeft: '0.2rem' }}>*</span>}
        </label>
      )}
      <input required={required} {...props} style={{ borderColor: error ? 'var(--color-danger)' : undefined }} />
      {error && <span style={{ fontSize: '0.875rem', color: 'var(--color-danger)', lineHeight: 1.4 }}>{error}</span>}
      {hint && !error && <span style={{ fontSize: '0.875rem', color: 'var(--color-muted)', lineHeight: 1.4 }}>{hint}</span>}
    </div>
  );
}

export function Select({ label, error, required, children, style = {}, ...props }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.375rem', ...style }}>
      {label && (
        <label style={{ fontSize: '0.9375rem', fontWeight: 600, color: error ? 'var(--color-danger)' : 'var(--color-text)', lineHeight: 1.4 }}>
          {label}{required && <span style={{ color: 'var(--color-danger)', marginLeft: '0.2rem' }}>*</span>}
        </label>
      )}
      <select required={required} {...props} style={{ borderColor: error ? 'var(--color-danger)' : undefined }}>
        {children}
      </select>
      {error && <span style={{ fontSize: '0.875rem', color: 'var(--color-danger)', lineHeight: 1.4 }}>{error}</span>}
    </div>
  );
}
